// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"
// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//
// If you have dependencies that try to import CSS, esbuild will generate a separate `app.css` file.
// To load it, simply add a second `<link>` to your `root.html.heex` file.
// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "./_external/static/phoenix_html.js";
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "./_external/static/phoenix.mjs";
import { LiveSocket } from "./_external/static/phoenix_live_view.esm.js";
import { hooks as colocatedHooks } from "./_external/deepblue_admin/index.js";
import AutoClearFlash from "./hooks/auto_clear_flash.js";
import DropdownMultiSelect from "./hooks/dropdown_multi_select.js";
import ClipboardCopy from "./hooks/clipboard_copy.js";
import CaptchaRefresh from "./hooks/captcha_refresh.js";
import initConfirmDialog from "./confirm_dialog.js";
import "./_external/vendor/topbar.js";
import "./theme.js";
initConfirmDialog();
const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
const liveSocket = new LiveSocket("/live", Socket, {
	longPollFallbackMs: 5e3,
	params: { _csrf_token: csrfToken },
	hooks: {
		...colocatedHooks,
		AutoClearFlash,
		"DeepblueAdmin.CoreComponents.AutoClearFlash": AutoClearFlash,
		DropdownMultiSelect,
		"DeepblueAdmin.CoreComponents.DropdownMultiSelect": DropdownMultiSelect,
		ClipboardCopy,
		"DeepblueAdmin.CoreComponents.ClipboardCopy": ClipboardCopy,
		CaptchaRefresh,
		"DeepblueAdmin.UserLoginLive.CaptchaRefresh": CaptchaRefresh
	}
});
// ── 跨连接残留频道自愈 ──
// phoenix 的 pagehide→disconnect 走 teardown（连接的 onclose 被置空），频道不会进入
// errored；页面从 BFCache 恢复时 pageshow→connect 建立新连接，频道仍带着旧连接的
// joined 状态。此后所有 push 都打到服务端已不存在的 topic 上（控制台持续
// "unmatched topic"，交互全部无效，只能整页刷新救回）。LiveView 自带的
// pageshow(persisted)→reload 兜底在部分浏览器时序下不触发，所以这里补两道：
//   1) 新连接建立时，仍处于 joined 的频道必是跨连接残留 → 立即静默重加入；
//   2) push 收到 unmatched topic 错误回复的频道同样重加入（覆盖同连接上频道
//      死亡但 phx_close 丢失的场景）。
const healStaleChannel = (channel) => {
	// 先置 errored 再 rejoin：复用 phoenix 标准恢复路径（重新 phx_join），
	// 避免 rejoin 里 leaveOpenTopic 把自己误判成重复频道，也不触发 View 的错误展示
	channel.state = "errored";
	channel.rejoin();
};
liveSocket.socket.onOpen(() => {
	for (const channel of liveSocket.socket.channels) {
		if (channel.isJoined()) {
			console.warn(`[liveview] 自愈：跨连接残留的 joined 频道，重新加入 ${channel.topic}`);
			healStaleChannel(channel);
		}
	}
});
liveSocket.socket.onMessage((msg) => {
	const payload = msg && msg.payload;
	if (msg && msg.event === "phx_reply" && payload && payload.status === "error" && payload.response && payload.response.reason === "unmatched topic") {
		const channel = liveSocket.socket.channels.find((c) => c.topic === msg.topic);
		if (channel && channel.isJoined()) {
			console.warn(`[liveview] 自愈：收到 unmatched topic，重新加入 ${channel.topic}`);
			healStaleChannel(channel);
		}
	}
});
// L3-03：顶部进度条读取当前 daisyUI 主题主色，避免复制主题值。
const themePrimary = getComputedStyle(document.documentElement).getPropertyValue("--color-primary").trim();
const TOPBAR_BAR_COLORS = { 0: themePrimary || "#2563eb" };
const TOPBAR_SHADOW_COLOR = "rgba(0, 0, 0, .3)";
const closeAdminDrawer = () => {
	const toggle = document.getElementById("admin-drawer-toggle");
	if (toggle) toggle.checked = false;
};
window.addEventListener("phx:close-admin-drawer", closeAdminDrawer);
// Show progress bar on live navigation and form submits
window.topbar.config({
	barColors: TOPBAR_BAR_COLORS,
	shadowColor: TOPBAR_SHADOW_COLOR
});
window.addEventListener("phx:page-loading-start", (_info) => {
	closeAdminDrawer();
	window.topbar.show(300);
});
window.addEventListener("phx:page-loading-stop", (_info) => window.topbar.hide());
// connect if there are any LiveViews on the page
liveSocket.connect();
// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;
// The lines below enable quality of life phoenix_live_reload
// development features:
//
//     1. stream server logs to the browser console
//     2. click on elements to jump to their definitions in your code editor
//
if (typeof process === "undefined" || process.env.NODE_ENV === "development") {
	window.addEventListener("phx:live_reload:attached", ({ detail: reloader }) => {
		// Enable server log streaming to client.
		// Disable with reloader.disableServerLogs()
		// Open configured PLUG_EDITOR at file:line of the clicked element's HEEx component
		//
		//   * click with "c" key pressed to open at caller location
		//   * click with "d" key pressed to open at function component definition location
		let keyDown;
		window.addEventListener("keydown", (e) => keyDown = e.key);
		window.addEventListener("keyup", (_e) => keyDown = null);
		window.addEventListener("click", (e) => {
			if (keyDown === "c") {
				e.preventDefault();
				e.stopImmediatePropagation();
				reloader.openEditorAtCaller(e.target);
			} else if (keyDown === "d") {
				e.preventDefault();
				e.stopImmediatePropagation();
				reloader.openEditorAtDef(e.target);
			}
		}, true);
		window.liveReloader = reloader;
	});
}
